import React, { useEffect } from 'react';
import Animated from 'components/generals/AnimatedComponent';
import rtLogo from 'assets/images/logos/rootstoken__white.png';
import mgLogo from 'assets/images/logos/maguey-logo-token.png';
import flLogo from 'assets/images/logos/fullneslad-logo-cream.png';
import ccLogo from 'assets/images/logos/cocoa-logo-cream.png';
import spLogo from 'assets/images/logos/spot-logo-cream.png';
export default function Home__section__12() {
    return (
        <main className="nv__section nv__section--no-margin nv__hp__section__12" id="nosotros">
            <section className="nv__section__container">
                <div className="infoBlock">
                    <div className="infoBlock__logo">
                        <Animated animation={'animate__fadeInDown animate__delay-1s'}>
                            <img src={rtLogo} alt="Roots Token" />
                        </Animated>
                    </div>

                    <Animated animation={'animate__fadeInDown animate__delay-2s'}>
                        <h1>Un proyecto estructurado por Multiassets</h1>
                    </Animated>

                    <Animated animation={'animate__fadeInDown animate__delay-3s'}>
                        <p>
                            Descubre un proyecto innovador diseñado y estructurado por Multiassets.
                            En ROOTSTOKEN, fusionamos la visión de Multiassets con tecnología de
                            vanguardia para ofrecerte una experiencia única con diferentes productos
                            que se adaptan a tus gustos y necesidades.
                        </p>
                    </Animated>

                    {/* <Animated animation={'animate__fadeInDown animate__delay-4s'}>
                        <div className="infoBlock__logos__container">
                            <img src={mgLogo} alt="Maguey Token" />
                            <img src={flLogo} alt="Fullnesland" />
                            <img src={ccLogo} alt="Cocoa Token" />
                            <img src={spLogo} alt="Spoot of The World" />
                        </div>
                    </Animated> */}

                    <Animated animation={'animate__fadeInDown animate__delay-5s'}>
                        <div className="infoBlock__info__contaner">
                            <p>
                                Únete a nuestra comunidad y descubre un nuevo camino hacia el éxito
                                financiero. Con ROOTSTOKEN, el futuro esta en tus manos.
                            </p>

                            <p>
                                Nuestro objetivo es brindarte las herramientas necesarias para que
                                puedas alcanzar tus metas financieras de manera confiable y
                                sencilla.
                            </p>
                        </div>
                    </Animated>
                </div>
            </section>
        </main>
    );
}
